<script>
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {ref} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import {useRoute} from "vue-router";
import $ from "jquery";
import {useStore} from "vuex";

export default {
  name: "DetailsOrder",
  components: {LoadingPage},
  setup(){

    let store = useStore()
    let commission_shop = parseInt(store.state.Profile.commission)

    let loading = ref(false)

    let oid = useRoute().params.oid

    let details_order = ref(null)

    let dialog = ref(false)
    let data_cheque = ref({
      oid: null,
      code: null,
      price_all: null,
      commission: null,
    })


    function my_orders() {

      loading.value = true
      FreeWorld.Heisenberg({}, 'orders', true).then((res) => {

        loading.value = false

        res.data.forEach((item)=>{
          if (item.id == oid) {details_order.value = item ; return false}
        })

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, my_orders)
      })

    }
    my_orders()

    function cancel_orders() {

      Swals.Question('آیا از لغو سفارش اطمینان دارید؟', 'لغو سفارش').then((res) => {
        if (res.isConfirmed) {

          loading.value = true
          FreeWorld.Heisenberg({action: 'cancel', oid: details_order.value.id}, 'shop/orders_act', true).then((res) => {

            if (res.data.status === 'ok') {
              Swals.Done('سفارش شما با موفقیت لغو شد')
              my_orders()
            } else {
              loading.value = false
              Swals.Fault('متاسفانه سفارش شما لغو نشد!')
            }

          }).catch((res) => {
            loading.value = false
            Swals.Catch(res, () => {
              cancel_orders()
            })
          })

        }
      })

    }
    function accept_order() {

      Swals.Question('سفارش ' + details_order.value.code + ' را قبول میکنید؟', 'قبول سفارش').then((res) => {

        if (res.isConfirmed) {

          loading.value = true
          FreeWorld.Heisenberg({action:'accept', oid:details_order.value.id}, 'shop/orders_act', true).then((res) => {

            if (res.data.status === 'ok') {
              Swals.Done('سفارش مورد نظر با موفقیت قبول شد')
              my_orders()
            } else {
              loading.value = false
              Swals.Fault('متاسفانه سفارش مورد نظر شما قبول نشد!')
            }

          }).catch((res) => {
            loading.value = false
            Swals.Catch(res, () => {accept_order()})
          })

        }

      })

    }
    function accept_cheque(type) {

      switch (type) {
        case 'show' :
          if (!details_order.value.cheque_check){Swals.Warning('درحال حاضر چک خریدار از طرف مدیریت تایید نشده است');return false}
          if (!dialog.value){
            data_cheque.value.code = details_order.value.code
            data_cheque.value.price_all = details_order.value.price
            data_cheque.value.commission = (details_order.value.price * commission_shop) / 100
            $("#dialog").removeClass('animate__fadeOut').addClass('animate__fadeIn')
            dialog.value = true
          }else {
            $("#dialog").removeClass('animate__fadeIn').addClass('animate__fadeOut')
            setTimeout(()=>{
              dialog.value = false
            },700)
          }
          break;

        case 'wallet' :
          console.log(type)
          break;

        case 'pay' :
          console.log(type)
          break;
      }

    }
    function sending_order() {

      if (details_order.value.status === 3 && details_order.value.cheque_commission === 0){Swals.Warning('لطفا ابتدا کمسیون اپلیکیشن را پرداخت کنید!');return false}

      loading.value = true
      FreeWorld.Heisenberg({action:'send', oid:details_order.value.id}, 'shop/orders_act', true).then((res) => {

        if (res.data.status === 'ok') {
          Swals.Done('سفارش مورد نظر با موفقیت ارسال شد')
          my_orders(false)
        } else if(res.data.event === 'please pay commission') {
          loading.value = false
          Swals.Fault('لطفا ابتدا کمسیون اپلیکیشن را پرداخت کنید!')
        }else{
          loading.value = false
          Swals.Fault('متاسفانه سفارش مورد نظر شما ارسال نشد!')
        }

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, () => {sending_order()})
      })

    }
    function delivery_order() {

      Swals.Question('سفارش ' + details_order.value.code + ' را تکمیل میکنید؟', 'تکمیل سفارش').then((res) => {

        if (res.isConfirmed) {

          loading.value = true
          FreeWorld.Heisenberg({action:'delivery', oid:details_order.value.id}, 'shop/orders_act', true).then((res) => {

            if (res.data.status === 'ok') {
              Swals.Done('سفارش مورد نظر با موفقیت تکمیل شد')
              my_orders(false)
            } else {
              loading.value = false
              Swals.Fault('متاسفانه سفارش مورد نظر شما تکمیل نشد!')
            }

          }).catch((res) => {
            loading.value = false
            Swals.Catch(res, () => {delivery_order()})
          })

        }

      })

    }


    return{

      loading,
      details_order,
      accept_order,
      cancel_orders,
      accept_cheque,
      data_cheque,
      dialog,
      sending_order,
      delivery_order,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>
  <div v-if="dialog" @click="accept_cheque('show')" class="bg_dialog"></div>

  <div id="main" :class="loading ? 'activeClass':'' " class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p class="animate__animated animate__fadeIn font-color font-bold">جزئیات سفارش</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>

  <div v-if="details_order !== null" class="mt-2 p-body animate__animated animate__fadeInRight">
    <!-- == -->
    <div class="holder-element-order shadow-custom my-4 position-relative">

      <div class="d-flex align-items-center justify-content-between flex-row-reverse">
        <div class="d-flex align-items-center">
          <img v-if="details_order.pay_type === 'cheque'" style="width: 35px" class="ml-2"
               src="../assets/img/shopping-list.svg" alt="">
          <p class="text-condition-cancellation text-white text-center rounded-3 p-2 font-6">{{ details_order.status_order }}</p>
        </div>

        <div class=" overflow-hidden">
          <p class="font-4 font-bold" :class="{'txtoverflow':details_order.username.length > 23}">{{ details_order.username }}</p>
        </div>
      </div>

      <hr class="hr-order  bg-color">

      <div class="d-flex align-items-center justify-content-between">
        <p class="font-5 m-0">تاریخ سفارش</p>

        <div class="data-left d-flex justify-content-center">
          <p class="font-5 m-0">{{ details_order.day }}</p>
          <p class="font-5 m-0 mx-3">{{ details_order.date }}</p>
          <p class="font-5 m-0">{{ details_order.time }}</p>
        </div>
      </div>

      <hr class="hr-order bg-color">

      <div class="d-flex justify-content-between">
        <p class="font-5 m-0">کد رهگیری</p>
        <p class="font-5 m-0 tracking-Code">{{ details_order.code }}</p>
      </div>

      <hr class="hr-order  bg-color">

      <div class="d-flex align-items-center justify-content-between">
        <p class="font-5 m-0">مبلغ کل سفارش</p>

        <div class="d-flex">
          <p class="font-5 m-0">{{ details_order.price.toLocaleString() }}</p>
          &nbsp;
          <p class="font-5 m-0">تومان</p>
        </div>
      </div>

      <hr class="hr-order  bg-color">

      <div class="d-flex justify-content-between align-items-center">
        <p class="font-5 m-0">مبلغ تخفیف</p>

        <div class="d-flex ">
          <p class="font-5 m-0">{{ details_order.price_off.toLocaleString() }}</p>
          &nbsp;
          <p class="font-5 m-0">تومان</p>
        </div>
      </div>

      <hr class="hr-order  bg-color">

      <div class="d-flex justify-content-between align-items-center">
        <p class="font-5 m-0">وضعیت پرداخت</p>

        <div class="d-flex ">
          <p class="font-5 m-0">{{ details_order.pay_status }}</p>
        </div>
      </div>

      <hr class="hr-order  bg-color">

      <div class="d-flex justify-content-between align-items-center">
        <p class="font-5 m-0">طریقه پرداخت</p>

        <div class="d-flex ">
          <p class="font-5 m-0">{{ details_order.pay_status }}</p>
        </div>
      </div>

      <hr class="hr-order bg-color">

      <div class="d-flex justify-content-between align-items-center">
        <p class="font-5 m-0">شهر و استان محل سفارش </p>

        <div class="d-flex ">
          <p class="font-5 m-0">{{ details_order.prov }} - {{ details_order.city }}</p>
        </div>
      </div>

      <hr class="hr-order bg-color">

      <div class="d-flex justify-content-between align-items-center">
        <p class="font-5 m-0">آدرس</p>

        <div dir="rtl" class="d-flex justify-content-end w-65">
          <p class="font-5 m-0">{{ details_order.address }}</p>
        </div>
      </div>


      <div v-if="details_order.info !== null" class="">
        <hr class="hr-order bg-color">

        <div class="d-flex justify-content-between align-items-center">
          <p class="font-5 m-0">توضیحات سفارش</p>

          <div dir="rtl" class="d-flex justify-content-end w-65">
            <p class="font-5 m-0">{{ details_order.info }}</p>
          </div>
        </div>
      </div>

      <div v-if="details_order.factor === 1" class="">
        <hr class="hr-order bg-color">

        <div class="d-flex justify-content-between align-items-center">
          <p class="font-5 m-0 w-60">خریدار درخواست فاکتور رسمی دارد</p>

          <div dir="rtl" class="d-flex flex-column justify-content-end">
            <p class="font-5 m-0 text-left">کد ملی : {{ details_order.user_codeid }}</p>
            <p class="font-5 m-0 text-left">کد پستی : {{ details_order.user_codepost }}</p>
          </div>
        </div>
      </div>

      <hr class="hr-order bg-color">

      <p class="font-4 mb-2">
        اقلام سفارش
      </p>

      <div id="list_orders" class="holder-img-food">

        <div v-for="prod in details_order.products" :key="prod.id" style="width: 170px;min-width: 170px"
             class="d-flex justify-content-between mx-1 animate__animated animate__fadeInRight">
          <div style="height: 75px" class="w-50 animated-background rounded-3">
            <img class="img-food-order w-100 rounded-3" :src="prod.pic" alt="">
          </div>

          <div class="mx-1 w-50 py-2 d-flex flex-column justify-content-between">
            <div class="overflow-hidden">
              <p :class="{'txtoverflow':prod.name.length > 15}" class="font-6 mb-2 text-end font-bold">{{
                  prod.name
                }}</p>
            </div>

            <p class="d-flex m-0 p-1 font-5 justify-content-center w-66 bg-dark-subtle rounded-pill font-color ">
                <span>
                {{ prod.number }}
              </span>
              &nbsp;
              <span>
                 عدد
                </span>
            </p>
          </div>
        </div>

      </div>

      <hr class="hr-order  bg-color">

      <div class="animate__animated animate__fadeInDown">

        <div class="w-100 d-flex justify-space-between align-items-center mt-3" v-if="details_order.status === 1">
          <v-btn @click="accept_order()"
                 class="font-4 rounded-3 border-0 p-2 bg-green w-45 text-white h-100 shadow-custom">قبول سفارش
          </v-btn>
          <v-btn @click="cancel_orders()"
                 class="font-4 rounded-3 border-0 p-2 bg-danger w-45 text-white h-100 shadow-custom">لغو سفارش
          </v-btn>
        </div>

        <div v-if="details_order.status === 3 || details_order.status === 4" class="w-100 d-flex mt-3" :class="details_order.status === 3  && details_order.cheque_commission === 0 ? 'justify-space-between':'justify-center'">
          <v-btn class="font-4 rounded-3 border-0 p-2 bg-yellow h-100 shadow-custom"
                 @click="sending_order()" :class="details_order.status === 3 && details_order.cheque_commission === 0 ? 'w-35':'w-60'">آماده برای ارسال
          </v-btn>

          <v-btn v-if="details_order.status === 3 && details_order.cheque_commission === 0" @click="accept_cheque('show')"
                 class="font-4 rounded-3 border-0 p-2 bg-green w-60 text-white h-100 shadow-custom">پرداخت کمسیون اپلیکیشن</v-btn>
        </div>

        <div v-if="details_order.status === 5" class="w-100 d-flex justify-content-center mt-3">
          <v-btn @click="delivery_order()" class="font-4 rounded-3 border-0 p-2 bg-color-light w-60 text-white h-100 shadow-custom">تکمیل سفارش</v-btn>
        </div>

      </div>
    </div>

  </div>



    <div v-if="dialog" id="dialog" class="dialog max_width p-body animate__animated animate__fadeIn">
      <div class="bg-white rounded-4">

        <div style="height: 45px"
             class="bg-color d-flex justify-content-center align-items-center rounded-top-4 text-center position-relative">
          <img style="height: 10vh;left: 0" class="position-absolute bottom-0"
               src="../assets/img/icon_done_dialog.svg" alt="">
          <p class="text-white font-4">ثبت نهایی خرید</p>
        </div>

        <div class="p-4">

          <div class="d-flex justify-space-between align-items-center p-3">
            <p class="font-5">شماره سفارش</p>

            <p class="font-5 font-bold">{{ data_cheque.code }}</p>
          </div>

          <div class="hr_div bg-color-blue-light my-2"></div>

          <div class="d-flex justify-space-between align-items-center p-3">
            <p class="font-5">مبلغ کل سفارش</p>

            <p class="font-5 font-bold d-flex font-color-green">
              <span>{{ data_cheque.price_all.toLocaleString() }}</span>
              <span class="mr-1">تومان</span>
            </p>
          </div>

          <div class="hr_div bg-color-blue-light my-2"></div>

          <div class="d-flex justify-space-between align-items-center p-3">
            <p class="font-5">مبلغ کسر شده بابت کمیسیون</p>

            <p class="font-5 font-bold d-flex font-color-green">
              <span>{{ data_cheque.commission.toLocaleString() }}</span>
              <span class="mr-1">تومان</span>
            </p>
          </div>

          <div class="hr_div bg-color-blue-light my-2"></div>

          <div class="d-flex justify-space-between align-items-center rounded-3 bg-color-blue-light p-3">
            <p class="font-5">مبلغ قابل پرداخت</p>

            <p class="font-5 font-bold d-flex font-color-green">
              <span>{{ data_cheque.commission.toLocaleString() }}</span>
              <span class="mr-1">تومان</span>
            </p>
          </div>

          <div class="d-flex justify-space-between align-items-center mt-5">
            <v-btn @click="accept_cheque('pay')" class="w-45 py-3 font-5 bg-green rounded-3 text-white h-100">پرداخت از درگاه بانکی</v-btn>
            <v-btn @click="accept_cheque('wallet')" class="w-45 py-3 font-5 bg-color rounded-3 text-white h-100">پرداخت از کیف پول</v-btn>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>


<style scoped>

.holder-element-order {
  width: 100%;
  border-radius: 10px;
  padding: 20px 25px;
}


.text-condition-cancellation {
  background-color: #b6b6b6;
  padding: 5px 15px;
}

.hr-order {
  width: 100%;
  /* margin: 10px 0 !important; */
}


.holder-img-food {
  padding: 5px 0;
  overflow-x: scroll;
  display: flex;
}

.holder-img-food::-webkit-scrollbar {
  display: none;
}

.img-food-order {
  height: 75px;
}


</style>